import Modal from "../../../components/Modal/Modal";
import React from "react";
import { useApp } from "../../../contexts";
import styled from "styled-components";
import { useWindowSize } from "../../../hook/useWindowSize";
import { useEffect, useState, useCallback } from "react";
import { getPropByLanguage } from "../../../utils/Language";
import NumberFormat from "react-number-format";

import {
  baseCurrencyCode,
  validateDecimalSeparator,
  prefixCcySymbol,
  suffixCcySymbol,
  thousandSeparatorByCurrency,
  decimalSeparatorByCurrency,
} from "../../../utils/Currency";
import {
  RoundNumberOfDigit,
  RoundNumberOfDigitSGT,
} from "../../../utils/helper";
import { roundNumber } from "../../../services/app";
import { useMemo } from "react";

const ContentWaper = styled.div`
  max-height: 80vh;
  overflow-y: auto;
  &::-webkit-scrollbar {
    display: none;
  }
`;
const digitETH = 8;
export const ModalDetail = ({ value, ...props }) => {
  const {
    T,
    language,
    convertToLocalCurrency,
    formatLocalCurrency,
    getCurrency,
    user,
  } = useApp();

  const onClose = () => {
    props.onClose();
  };
  const size = useWindowSize();
  const isMobile = size.width < 1024 ? true : false;
  const { data, tab, breedOptions } = { value, ...props };
  const [total, setTotal] = useState(0);
  const [orderFee, setOrderFee] = useState(0);
  const [totalPrice, setTotalPrice] = useState(0);
  const [totalRefund, setTotalRefund] = useState(0);
  const [items, setItems] = useState([]);
  const itemClass = (itemId) => {
    const arr = [1, 2, 3, 4, 5, 6, 7];
    const random = itemId % 7;
    return `suzu-card-image-${arr[random]}`;
  };

  const convertItemPrice = (item) => {
    return convertToLocalCurrency(
      item?.price,
      item?.ccy || "USD",
      getCurrency()
    );
  };
  const itemName = useCallback(
    (item) => {
      let name = T(item?.item_name);
      if (item?.item_type == 9) {
        const breedSelected = (breedOptions || []).find(
          (option) => option.name == item.item_name
        );
        if (breedSelected) {
          name = breedSelected.nameTranslate[getPropByLanguage(language)];
        }
      }
      return name;
    },
    [items, breedOptions, language]
  );
  useEffect(() => {
    if (data) {
      const items = data.orders_item || [];
      const newItems = [];
      let total = 0;
      let totalPrice = 0;
      let refund = 0;

      for (const item of items) {
        const convertItemPrice = convertToLocalCurrency(
          item.price,
          item.ccy,
          getCurrency()
        );
        newItems.push({
          ...item,
          convertPrice: convertItemPrice,
        });
        total += item.quantity;
        totalPrice += Number(item.quantity) * Number(item.price);
        refund += Number(item.refunded_qty) * Number(item.price);
        setOrderFee(data.fee_amount);
      }
      setTotalRefund(refund);
      setTotal(total);
      setTotalPrice(totalPrice);
      setItems(newItems);
    } else {
      setItems([]);
    }
  }, [data]);

  const viewOnMallUrl = useMemo(() => {
    const isJpUser = user?.country_code === "JP";
    if (data?.orders_item?.[0]?.item_type === 11) {
      if (isJpUser) {
        return `${user.store_shopify}/a/sz_subscriptions?page=1&lang=${user.language}`;
      }
      return `${user.store_shopify}/a/subscriptions/manage?page=1&lang=${user.language}`;
    }
    return data?.refer_id;
  }, [data, user]);

  return (
    <Modal onClose={onClose}>
      <Modal.ModalBg2 onClose={onClose} />
      <Modal.Container2
        width="1200px"
        onClose={onClose}
        className={"order-detail"}
      >
        <ContentWaper>
          <div className="text-black text-center font-medium text-[18px] lg:text-[25px] tracking-[-0.96px]">
            {props?.title}
          </div>
          <div
            className=" text-black mx-auto truncate w-[calc(100%-80px)] text-center
          text-[16px] lg:text-[18px]/[30px] font-medium"
          >
            <span>
              {data.order_name ?? ''}
            </span>
          </div>
          {data?.refer_id && (
            <a
              className="flex justify-center items-center !text-[#F3850F] underline 
            text-[16px] lg:text-[18px]/[30px] font-medium"
              href={viewOnMallUrl}
              target="_blank"
              rel="noreferrer"
            >
              {T("View on Mall")}
            </a>
          )}
          <div className="order-modal-body">
            {isMobile ? (
              <>
                {items?.map((item, index) => {
                  return (
                    <div
                      key={index}
                      className={`bg-[#fff] flex flex-start gap[6px] lg:gap-[15px] rounded-[20px] p-[10px] my-[15px] ${
                        item?.item_type == 8 || item?.item_type == 11
                          ? "p-0 overflow-hidden"
                          : "p-[15px]"
                      }`}
                    >
                      <div
                        className={`w-[75px] h-[75px] rounded-[5px] overflow-hidden aspect-square`}
                      >
                        <img
                          src={item.item_image}
                          className={`w-full h-full ${
                            item?.item_type === 10
                              ? "object-contain pt-1"
                              : "object-cover"
                          } rounded-[5px]`}
                          alt=""
                        />
                      </div>
                      <div className="pl-[10px] flex-col justify-start w-[calc(100%-75px)] lg:w-[calc(100%-90px)]">
                        <div className="leading-[22px] font-[700] text-black text-[16px]">
                          {itemName(item)}
                        </div>
                        <div className="leading-[16px] font-[400] text-[#818181] text-[12px]">
                          #{item.id}
                        </div>
                        {item.level && (
                          <div className="leading-[16px] font-[400] text-[#818181] text-[12px]">
                            Lv{" "}
                            {Number(item.level) == 6
                              ? "King"
                              : Number(item.level)}
                          </div>
                        )}
                        <p className="leading-[24px] text-[12px] lg:text-[16px] text-[#666] font-[500] custom-mb-truncate mb-[1px]"></p>

                        {item?.item_type !== 10 ? (
                          <>
                            {item?.tag_nft_type == "motion" ? (
                              <div className="leading-[16px] font-[400] text-[#818181] text-[12px]">
                                {T("Motion Art")}
                              </div>
                            ) : (
                              <></>
                            )}
                            {item?.tag_nft_type == "photo" ? (
                              <div className="leading-[16px] font-[400] text-[#818181] text-[12px]">
                                {T("Photo Art")}
                              </div>
                            ) : (
                              <></>
                            )}
                          </>
                        ) : (
                          <></>
                        )}
                        <div className="flex justify-between items-start w-full leading-[22px]">
                          <div className="text-black text-[14px]">
                            {T("Price")}
                          </div>
                          <div className="text-black text-[14px] whitespace-nowrap">
                            {["ETH", "SGT"].includes(item.ccy) ? (
                              <NumberFormat
                                value={Number(item.price)}
                                displayType={"text"}
                                thousandSeparator={thousandSeparatorByCurrency(
                                  item.ccy
                                )}
                                decimalSeparator={decimalSeparatorByCurrency(
                                  item.ccy
                                )}
                                suffix={" " + item.ccy}
                                decimalScale={digitETH}
                              />
                            ) : (
                              <NumberFormat
                                value={Number(item.price)}
                                displayType={"text"}
                                thousandSeparator={thousandSeparatorByCurrency(
                                  item.ccy
                                )}
                                decimalSeparator={decimalSeparatorByCurrency(
                                  item.ccy
                                )}
                                prefix={prefixCcySymbol(true, item.ccy)}
                                suffix={` ${suffixCcySymbol(true, item.ccy)}`}
                                decimalScale={validateDecimalSeparator(
                                  baseCurrencyCode(true, item.ccy)
                                )}
                              />
                            )}
                          </div>
                        </div>
                        <div className="flex justify-between items-start w-full leading-[22px]">
                          <div className="text-black text-[14px]">
                            {T("Refunded Qty")}
                          </div>
                          <div className="text-black text-[14px] whitespace-nowrap">
                            {item.refunded_qty}
                          </div>
                        </div>
                        <div className="flex justify-between items-start w-full leading-[22px]">
                          <div className="text-black text-[14px]">
                            {T("Subtotal")}
                          </div>
                          <div className="text-black text-[14px]  whitespace-nowrap">
                            {["ETH", "SGT"].includes(item.ccy) ? (
                              <NumberFormat
                                value={
                                  Number(item.quantity) * Number(item.price)
                                }
                                displayType={"text"}
                                thousandSeparator={thousandSeparatorByCurrency(
                                  item.ccy
                                )}
                                decimalSeparator={decimalSeparatorByCurrency(
                                  item.ccy
                                )}
                                suffix={" " + item.ccy}
                                decimalScale={digitETH}
                              />
                            ) : (
                              <NumberFormat
                                value={
                                  Number(item.quantity) * Number(item.price)
                                }
                                displayType={"text"}
                                thousandSeparator={thousandSeparatorByCurrency(
                                  item.ccy
                                )}
                                decimalSeparator={decimalSeparatorByCurrency(
                                  item.ccy
                                )}
                                prefix={prefixCcySymbol(true, item.ccy)}
                                suffix={` ${suffixCcySymbol(true, item.ccy)}`}
                                decimalScale={validateDecimalSeparator(
                                  baseCurrencyCode(true, item.ccy)
                                )}
                              />
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </>
            ) : (
              <>
                <div className="order-modal-table-header grid grid-cols-12 bg-[#FFF] h-[55px] mt-[30px]">
                  <div className="text-center text-black leading-[55px] font-semibold">
                    #
                  </div>
                  <div className="col-span-4 text-left text-black leading-[55px] font-semibold">
                    {T("Item")}
                  </div>
                  <div className="col-span-2 text-center text-black leading-[55px] font-semibold">
                    {T("Price")}
                  </div>
                  <div className="col-span-1 text-center text-black leading-[55px] font-semibold">
                    {T("Quantity")}
                  </div>
                  <div className="col-span-2 text-center text-black leading-[55px] font-semibold">
                    {T("Refunded Quantity")}
                  </div>
                  <div className="col-span-2 text-center text-black leading-[55px] font-semibold">
                    {T("Subtotal")}
                  </div>
                </div>
                {items.map((item, index) => {
                  return (
                    <div
                      className={`order-modal-table-header grid grid-cols-12 py-[15px] ${
                        index != items.length - 1
                          ? "border-b border-solid border-[#ededed]"
                          : ""
                      }`}
                    >
                      <div className="text-center text-black leading-[55px] text-bold">
                        {index + 1}
                      </div>
                      <div className="col-span-4 text-center text-black leading-[55px] text-bold flex">
                        <div
                          className={`w-[95px] aspect-[1/1] h-[95px] overflow-hidden rounded-[5px] bg-[#ededed] ${itemClass(
                            item.id
                          )}`}
                        >
                          <img
                            src={item.item_image}
                            className={`w-full h-full ${
                              item?.item_type === 10
                                ? "object-contain pt-1"
                                : "object-cover"
                            } rounded-[5px] overflow-hidden`}
                            alt=""
                          />
                        </div>
                        <div className="pl-[10px] flex-col justify-start">
                          <div className="leading-[24px] text-left">
                            {itemName(item)}
                          </div>
                          <div className="leading-[18px] flex flex-start text-[#818181] text-[12px]">
                            #{item.id}
                          </div>
                          {item?.level && (
                            <div className="leading-[18px] flex flex-start text-[#818181] text-[12px]">
                              Lv{" "}
                              {Number(item?.level) == 6
                                ? "King"
                                : Number(item?.level)}
                            </div>
                          )}
                          {item?.item_type !== 10 ? (
                            <>
                              {item?.tag_nft_type == "motion" ? (
                                <div className="leading-[18px] flex flex-start text-[#818181] text-[12px]">
                                  {T("Motion Art")}
                                </div>
                              ) : (
                                <></>
                              )}
                              {item?.tag_nft_type == "photo" ? (
                                <div className="leading-[18px] flex flex-start text-[#818181] text-[12px]">
                                  {T("Photo Art")}
                                </div>
                              ) : (
                                <></>
                              )}
                            </>
                          ) : (
                            <></>
                          )}
                        </div>
                      </div>
                      <div className="col-span-2 text-center text-black leading-[30px] text-bold">
                        <div className="order-item__value font-semibold">
                          {["ETH", "SGT"].includes(item.ccy) ? (
                            <NumberFormat
                              value={Number(item.price)}
                              displayType={"text"}
                              thousandSeparator={thousandSeparatorByCurrency(
                                item.ccy
                              )}
                              decimalSeparator={decimalSeparatorByCurrency(
                                item.ccy
                              )}
                              suffix={" " + item.ccy}
                              decimalScale={digitETH}
                            />
                          ) : (
                            <NumberFormat
                              value={Number(item.price)}
                              displayType={"text"}
                              thousandSeparator={thousandSeparatorByCurrency(
                                item.ccy
                              )}
                              decimalSeparator={decimalSeparatorByCurrency(
                                item.ccy
                              )}
                              prefix={prefixCcySymbol(true, item.ccy)}
                              suffix={` ${suffixCcySymbol(true, item.ccy)}`}
                              decimalScale={validateDecimalSeparator(
                                baseCurrencyCode(true, item.ccy)
                              )}
                            />
                          )}
                        </div>
                      </div>
                      <div className="col-span-1 text-center text-black leading-[30px] text-bold">
                        {item.quantity}
                      </div>
                      <div className="col-span-2 text-center text-black leading-[30px] text-bold">
                        {item.refunded_qty}
                      </div>
                      <div className="col-span-2 text-center text-black leading-[30px] text-bold">
                        <div className="order-item__value font-semibold">
                          {["ETH", "SGT"].includes(item.ccy) ? (
                            <NumberFormat
                              value={Number(item.price) * Number(item.quantity)}
                              displayType={"text"}
                              thousandSeparator={thousandSeparatorByCurrency(
                                item.ccy
                              )}
                              decimalSeparator={decimalSeparatorByCurrency(
                                item.ccy
                              )}
                              suffix={" " + item.ccy}
                              decimalScale={digitETH}
                            />
                          ) : (
                            <NumberFormat
                              value={Number(item.price) * Number(item.quantity)}
                              displayType={"text"}
                              thousandSeparator={thousandSeparatorByCurrency(
                                item.ccy
                              )}
                              decimalSeparator={decimalSeparatorByCurrency(
                                item.ccy
                              )}
                              prefix={prefixCcySymbol(true, item.ccy)}
                              suffix={` ${suffixCcySymbol(true, item.ccy)}`}
                              decimalScale={validateDecimalSeparator(
                                baseCurrencyCode(true, item.ccy)
                              )}
                            />
                          )}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </>
            )}
          </div>
          <div className="order-modal-sumary bg-[#F5AA194D] px-[15px] rounded-b-[30px] md:px-[70px] py-[20px] w-full md:rounded-b-[30px]">
            <div className="sumary-item">
              <div className="sumary-item-label text-black font-semibold text-[14px] lg:text-[16px]">
                {T("Order Amount")}
              </div>
              <div className="sumary-item-value text-black text-[16px] lg:text-[20px]">
                {data?.payment_detail?.network ? (
                  <NumberFormat
                    value={Number(data?.amount)}
                    displayType={"text"}
                    thousandSeparator={thousandSeparatorByCurrency(
                      data?.from_currency_code
                    )}
                    decimalSeparator={decimalSeparatorByCurrency(
                      data?.from_currency_code
                    )}
                    suffix={" " + data?.from_currency_code}
                    decimalScale={digitETH}
                  />
                ) : data?.payment_detail && data?.payment_detail?.ccy ? (
                  ["ETH", "SGT"].includes(data?.payment_detail?.ccy) ? (
                    <NumberFormat
                      value={Number(
                        data?.payment_detail?.order_amount ??
                          data?.payment_detail?.originalPrice
                      )}
                      displayType={"text"}
                      thousandSeparator={thousandSeparatorByCurrency(
                        data?.payment_detail?.ccy
                      )}
                      decimalSeparator={decimalSeparatorByCurrency(
                        data?.payment_detail?.ccy
                      )}
                      suffix={" " + data?.payment_detail?.ccy}
                      decimalScale={digitETH}
                    />
                  ) : (
                    <NumberFormat
                      value={Number(
                        data?.payment_detail?.order_amount ??
                          data?.payment_detail?.originalPrice
                      )}
                      displayType={"text"}
                      thousandSeparator={thousandSeparatorByCurrency(
                        data?.payment_detail?.ccy
                      )}
                      decimalSeparator={decimalSeparatorByCurrency(
                        data?.payment_detail?.ccy
                      )}
                      prefix={prefixCcySymbol(true, data?.payment_detail?.ccy)}
                      suffix={` ${suffixCcySymbol(
                        true,
                        data?.payment_detail?.ccy
                      )}`}
                      decimalScale={validateDecimalSeparator(
                        baseCurrencyCode(true, data?.payment_detail?.ccy)
                      )}
                    />
                  )
                ) : ["ETH", "SGT"].includes(data?.from_currency_code) ? (
                  <NumberFormat
                    value={Number(
                      data?.amount ??
                        data?.payment_detail?.originalPrice ??
                        data?.payment_detail?.order_amount
                    )}
                    displayType={"text"}
                    thousandSeparator={thousandSeparatorByCurrency(
                      data?.from_currency_code
                    )}
                    decimalSeparator={decimalSeparatorByCurrency(
                      data?.from_currency_code
                    )}
                    suffix={" " + data?.from_currency_code}
                    decimalScale={digitETH}
                  />
                ) : (
                  <NumberFormat
                    value={Number(
                      data?.amount ??
                        data?.payment_detail?.originalPrice ??
                        data?.payment_detail?.order_amount
                    )}
                    displayType={"text"}
                    thousandSeparator={thousandSeparatorByCurrency(
                      data?.from_currency_code
                    )}
                    decimalSeparator={decimalSeparatorByCurrency(
                      data?.from_currency_code
                    )}
                    prefix={prefixCcySymbol(true, data?.from_currency_code)}
                    suffix={` ${suffixCcySymbol(
                      true,
                      data?.from_currency_code
                    )}`}
                    decimalScale={validateDecimalSeparator(
                      baseCurrencyCode(true, data?.from_currency_code)
                    )}
                  />
                )}
              </div>
            </div>
            {totalRefund > 0 ? (
              <div className="sumary-item">
                <div className="sumary-item-label text-black font-semibold text-[14px] lg:text-[16px]">
                  {T("Refunded Amount")}
                </div>
                <div className="sumary-item-value text-black text-[16px] lg:text-[20px]">
                  {data?.payment_detail?.network ? (
                    <NumberFormat
                      value={Number(totalRefund)}
                      displayType={"text"}
                      thousandSeparator={thousandSeparatorByCurrency(
                        data?.from_currency_code
                      )}
                      decimalSeparator={decimalSeparatorByCurrency(
                        data?.from_currency_code
                      )}
                      suffix={" " + data?.from_currency_code}
                      decimalScale={digitETH}
                    />
                  ) : data?.payment_detail && data?.payment_detail?.ccy ? (
                    ["ETH", "SGT"].includes(data?.payment_detail?.ccy) ? (
                      <NumberFormat
                        value={Number(totalRefund)}
                        displayType={"text"}
                        thousandSeparator={thousandSeparatorByCurrency(
                          data?.payment_detail?.ccy
                        )}
                        decimalSeparator={decimalSeparatorByCurrency(
                          data?.payment_detail?.ccy
                        )}
                        suffix={" " + data?.payment_detail?.ccy}
                        decimalScale={digitETH}
                      />
                    ) : (
                      <NumberFormat
                        value={Number(totalRefund)}
                        displayType={"text"}
                        thousandSeparator={thousandSeparatorByCurrency(
                          data?.payment_detail?.ccy
                        )}
                        decimalSeparator={decimalSeparatorByCurrency(
                          data?.payment_detail?.ccy
                        )}
                        prefix={prefixCcySymbol(
                          true,
                          data?.payment_detail?.ccy
                        )}
                        suffix={` ${suffixCcySymbol(
                          true,
                          data?.payment_detail?.ccy
                        )}`}
                        decimalScale={validateDecimalSeparator(
                          baseCurrencyCode(true, data?.payment_detail?.ccy)
                        )}
                      />
                    )
                  ) : ["ETH", "SGT"].includes(data?.from_currency_code) ? (
                    <NumberFormat
                      value={Number(totalRefund)}
                      displayType={"text"}
                      thousandSeparator={thousandSeparatorByCurrency(
                        data?.from_currency_code
                      )}
                      decimalSeparator={decimalSeparatorByCurrency(
                        data?.from_currency_code
                      )}
                      suffix={" " + data?.from_currency_code}
                      decimalScale={digitETH}
                    />
                  ) : (
                    <NumberFormat
                      value={Number(totalRefund)}
                      displayType={"text"}
                      thousandSeparator={thousandSeparatorByCurrency(
                        data?.from_currency_code
                      )}
                      decimalSeparator={decimalSeparatorByCurrency(
                        data?.from_currency_code
                      )}
                      prefix={prefixCcySymbol(true, data?.from_currency_code)}
                      suffix={` ${suffixCcySymbol(
                        true,
                        data?.from_currency_code
                      )}`}
                      decimalScale={validateDecimalSeparator(
                        baseCurrencyCode(true, data?.from_currency_code)
                      )}
                    />
                  )}
                </div>
              </div>
            ) : (
              <></>
            )}
            {data?.payment_detail?.tax > 0 && (
              <div className="sumary-item">
                <div className="sumary-item-label text-black font-semibold text-[14px] lg:text-[16px]">
                  {T("Tax")}
                </div>
                <div className="sumary-item-value text-black text-[16px] lg:text-[20px]">
                  {["ETH", "SGT"].includes(data?.from_currency_code) ? (
                    <NumberFormat
                      value={Number(data?.payment_detail?.tax)}
                      displayType={"text"}
                      thousandSeparator={thousandSeparatorByCurrency(
                        data?.from_currency_code
                      )}
                      decimalSeparator={decimalSeparatorByCurrency(
                        data?.from_currency_code
                      )}
                      suffix={" " + data?.from_currency_code}
                      decimalScale={digitETH}
                    />
                  ) : (
                    <NumberFormat
                      value={Number(data?.payment_detail?.tax)}
                      displayType={"text"}
                      thousandSeparator={thousandSeparatorByCurrency(
                        data?.from_currency_code
                      )}
                      decimalSeparator={decimalSeparatorByCurrency(
                        data?.from_currency_code
                      )}
                      prefix={prefixCcySymbol(true, data?.from_currency_code)}
                      suffix={
                        " " + suffixCcySymbol(true, data?.from_currency_code)
                      }
                      decimalScale={validateDecimalSeparator(
                        baseCurrencyCode(true, data?.from_currency_code)
                      )}
                    />
                  )}
                </div>
              </div>
            )}
            {data?.payment_detail?.discount > 0 && (
              <div className="sumary-item">
                <div className="sumary-item-label text-black font-semibold text-[14px] lg:text-[16px]">
                  {T("Discount")}
                </div>
                <div className="sumary-item-value text-black text-[16px] lg:text-[20px]">
                  {["ETH", "SGT"].includes(data?.from_currency_code) ? (
                    <NumberFormat
                      value={Number(data?.payment_detail?.discount)}
                      displayType={"text"}
                      thousandSeparator={thousandSeparatorByCurrency(
                        data?.from_currency_code
                      )}
                      decimalSeparator={decimalSeparatorByCurrency(
                        data?.from_currency_code
                      )}
                      suffix={" " + data?.from_currency_code}
                      decimalScale={digitETH}
                    />
                  ) : (
                    <NumberFormat
                      value={Number(data?.payment_detail?.discount)}
                      displayType={"text"}
                      thousandSeparator={thousandSeparatorByCurrency(
                        data?.from_currency_code
                      )}
                      decimalSeparator={decimalSeparatorByCurrency(
                        data?.from_currency_code
                      )}
                      prefix={`- ${prefixCcySymbol(
                        true,
                        data?.from_currency_code
                      )}`}
                      suffix={
                        " " + suffixCcySymbol(true, data?.from_currency_code)
                      }
                      decimalScale={validateDecimalSeparator(
                        baseCurrencyCode(true, data?.from_currency_code)
                      )}
                    />
                  )}
                </div>
              </div>
            )}
            {data?.payment_detail?.shipping > 0 && (
              <div className="sumary-item">
                <div className="sumary-item-label text-black font-semibold text-[14px] lg:text-[16px]">
                  {T("Shipping Fee")}
                </div>
                <div className="sumary-item-value text-black text-[16px] lg:text-[20px]">
                  {["ETH", "SGT"].includes(data?.from_currency_code) ? (
                    <NumberFormat
                      value={Number(data?.payment_detail?.shipping)}
                      displayType={"text"}
                      thousandSeparator={thousandSeparatorByCurrency(
                        data?.from_currency_code
                      )}
                      decimalSeparator={decimalSeparatorByCurrency(
                        data?.from_currency_code
                      )}
                      suffix={" " + data?.from_currency_code}
                      decimalScale={digitETH}
                    />
                  ) : (
                    <NumberFormat
                      value={Number(data?.payment_detail?.shipping)}
                      displayType={"text"}
                      thousandSeparator={thousandSeparatorByCurrency(
                        data?.from_currency_code
                      )}
                      decimalSeparator={decimalSeparatorByCurrency(
                        data?.from_currency_code
                      )}
                      prefix={prefixCcySymbol(true, data?.from_currency_code)}
                      suffix={
                        " " + suffixCcySymbol(true, data?.from_currency_code)
                      }
                      decimalScale={validateDecimalSeparator(
                        baseCurrencyCode(true, data?.from_currency_code)
                      )}
                    />
                  )}
                </div>
              </div>
            )}
            {data?.fee_amount > 0 && (
              <div className="sumary-item">
                <div className="sumary-item-label text-black font-semibold text-[14px] lg:text-[16px]">
                  {data?.payment_detail?.ccy === "SGT" &&
                  !data?.payment_detail?.nftOrder
                    ? T("Estimated gas fee")
                    : T("Fee")}
                </div>
                <div className="sumary-item-value text-black text-[16px] lg:text-[20px]">
                  {data?.payment_detail?.nftOrder ? (
                    <NumberFormat
                      value={Number(data?.fee_amount)}
                      displayType={"text"}
                      thousandSeparator={thousandSeparatorByCurrency("POL")}
                      decimalSeparator={decimalSeparatorByCurrency("POL")}
                      suffix={" POL"}
                      decimalScale={digitETH}
                    />
                  ) : data?.payment_detail?.network ? (
                    <NumberFormat
                      value={Number(data?.fee_amount)}
                      displayType={"text"}
                      thousandSeparator={thousandSeparatorByCurrency(
                        data?.payment_detail?.network === "polygon"
                          ? "POL"
                          : "ETH"
                      )}
                      decimalSeparator={decimalSeparatorByCurrency(
                        data?.payment_detail?.network === "polygon"
                          ? "POL"
                          : "ETH"
                      )}
                      suffix={
                        " " +
                        (data?.payment_detail?.network === "polygon"
                          ? "POL"
                          : "ETH")
                      }
                      decimalScale={digitETH}
                    />
                  ) : data?.payment_detail && data?.payment_detail?.ccy ? (
                    ["ETH", "SGT"].includes(data?.payment_detail?.ccy) ? (
                      <NumberFormat
                        value={Number(
                          data?.payment_detail?.fee_amount ?? data?.fee_amount
                        )}
                        displayType={"text"}
                        thousandSeparator={thousandSeparatorByCurrency(
                          data?.payment_detail?.network === "polygon"
                            ? "POL"
                            : "ETH"
                        )}
                        decimalSeparator={decimalSeparatorByCurrency(
                          data?.payment_detail?.network === "polygon"
                            ? "POL"
                            : "ETH"
                        )}
                        suffix={
                          " " +
                          (data?.payment_detail?.network === "polygon"
                            ? "POL"
                            : "ETH")
                        }
                        decimalScale={digitETH}
                      />
                    ) : (
                      <NumberFormat
                        value={Number(data?.payment_detail?.fee_amount)}
                        displayType={"text"}
                        thousandSeparator={thousandSeparatorByCurrency(
                          data?.payment_detail?.ccy
                        )}
                        decimalSeparator={decimalSeparatorByCurrency(
                          data?.payment_detail?.ccy
                        )}
                        prefix={prefixCcySymbol(
                          true,
                          data?.payment_detail?.ccy
                        )}
                        suffix={` ${suffixCcySymbol(
                          true,
                          data?.payment_detail?.ccy
                        )}`}
                        decimalScale={validateDecimalSeparator(
                          baseCurrencyCode(true, data?.payment_detail?.ccy)
                        )}
                      />
                    )
                  ) : ["ETH", "SGT"].includes(data?.from_currency_code) ? (
                    <NumberFormat
                      value={Number(data?.fee_amount)}
                      displayType={"text"}
                      thousandSeparator={thousandSeparatorByCurrency(
                        data?.payment_detail?.network === "polygon"
                          ? "POL"
                          : "ETH"
                      )}
                      decimalSeparator={decimalSeparatorByCurrency(
                        data?.payment_detail?.network === "polygon"
                          ? "POL"
                          : "ETH"
                      )}
                      suffix={
                        " " +
                        (data?.payment_detail?.network === "polygon"
                          ? "POL"
                          : "ETH")
                      }
                      decimalScale={digitETH}
                    />
                  ) : (
                    <NumberFormat
                      value={Number(data?.fee_amount)}
                      displayType={"text"}
                      thousandSeparator={thousandSeparatorByCurrency(
                        data?.from_currency_code
                      )}
                      decimalSeparator={decimalSeparatorByCurrency(
                        data?.from_currency_code
                      )}
                      prefix={prefixCcySymbol(true, data?.from_currency_code)}
                      suffix={
                        " " + suffixCcySymbol(true, data?.from_currency_code)
                      }
                      decimalScale={validateDecimalSeparator(
                        baseCurrencyCode(true, data?.from_currency_code)
                      )}
                    />
                  )}
                </div>
              </div>
            )}
            <div className="sumary-item !items-baseline">
              <div className="sumary-item-label text-black font-semibold text-[14px] lg:text-[18px]">
                {total > 1
                  ? T("Total ({count} items)").replace("{count}", total)
                  : T("Total (1 item)")}
              </div>
              <div className="sumary-item-value text-[16px] lg:text-[20px] flex-col justify-end items-end gap-0">
                {data?.payment_detail?.nftOrder ? (
                  <NumberFormat
                    value={Number(data?.final_amount) - Number(totalRefund)}
                    displayType={"text"}
                    thousandSeparator={thousandSeparatorByCurrency(
                      data?.from_currency_code
                    )}
                    decimalSeparator={decimalSeparatorByCurrency(
                      data?.from_currency_code
                    )}
                    suffix={" " + data?.from_currency_code}
                    decimalScale={digitETH}
                  />
                ) : data?.payment_detail?.network ? (
                  <NumberFormat
                    value={Number(data?.final_amount) - Number(totalRefund)}
                    displayType={"text"}
                    thousandSeparator={thousandSeparatorByCurrency(
                      data?.from_currency_code
                    )}
                    decimalSeparator={decimalSeparatorByCurrency(
                      data?.from_currency_code
                    )}
                    suffix={" " + data?.from_currency_code}
                    decimalScale={digitETH}
                  />
                ) : data?.payment_detail && data?.payment_detail?.ccy ? (
                  ["ETH", "SGT"].includes(data?.payment_detail?.ccy) ? (
                    <NumberFormat
                      value={
                        Number(
                          data?.payment_detail?.total_amount ??
                            data?.payment_detail?.totalPrice
                        ) - Number(totalRefund)
                      }
                      displayType={"text"}
                      thousandSeparator={thousandSeparatorByCurrency(
                        data?.payment_detail?.ccy
                      )}
                      decimalSeparator={decimalSeparatorByCurrency(
                        data?.payment_detail?.ccy
                      )}
                      suffix={" " + data?.payment_detail?.ccy}
                      decimalScale={digitETH}
                    />
                  ) : (
                    <NumberFormat
                      value={
                        Number(
                          data?.payment_detail?.total_amount ??
                            data?.payment_detail?.totalPrice
                        ) - Number(totalRefund)
                      }
                      displayType={"text"}
                      thousandSeparator={thousandSeparatorByCurrency(
                        data?.payment_detail?.ccy
                      )}
                      decimalSeparator={decimalSeparatorByCurrency(
                        data?.payment_detail?.ccy
                      )}
                      prefix={prefixCcySymbol(true, data?.payment_detail?.ccy)}
                      suffix={` ${suffixCcySymbol(
                        true,
                        data?.payment_detail?.ccy
                      )}`}
                      decimalScale={validateDecimalSeparator(
                        baseCurrencyCode(true, data?.payment_detail?.ccy)
                      )}
                    />
                  )
                ) : ["ETH", "SGT"].includes(data?.from_currency_code) ? (
                  <NumberFormat
                    value={
                      Number(
                        data?.final_amount ??
                          data?.payment_detail?.totalPrice ??
                          data?.payment_detail?.total_amount
                      ) - Number(totalRefund)
                    }
                    displayType={"text"}
                    thousandSeparator={thousandSeparatorByCurrency(
                      data?.from_currency_code
                    )}
                    decimalSeparator={decimalSeparatorByCurrency(
                      data?.from_currency_code
                    )}
                    suffix={" " + data?.from_currency_code}
                    decimalScale={digitETH}
                  />
                ) : (
                  <NumberFormat
                    value={
                      Number(
                        data?.final_amount ??
                          data?.payment_detail?.totalPrice ??
                          data?.payment_detail?.total_amount
                      ) - Number(totalRefund)
                    }
                    displayType={"text"}
                    thousandSeparator={thousandSeparatorByCurrency(
                      data?.from_currency_code
                    )}
                    decimalSeparator={decimalSeparatorByCurrency(
                      data?.from_currency_code
                    )}
                    prefix={prefixCcySymbol(true, data?.from_currency_code)}
                    suffix={
                      " " + suffixCcySymbol(true, data?.from_currency_code)
                    }
                    decimalScale={validateDecimalSeparator(
                      baseCurrencyCode(true, data?.from_currency_code)
                    )}
                  />
                )}
                {data?.payment_detail?.network && (
                  <div className="text-[13px] lg:text-[15px] text-right mt-[-6px]">
                    (
                    {data?.payment_detail?.network === "polygon"
                      ? T("Polygon Main Network")
                      : T("Ethereum Main Network")}
                    )
                  </div>
                )}
              </div>
            </div>
          </div>
        </ContentWaper>
      </Modal.Container2>
    </Modal>
  );
};
